import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'

class CustomDRACOLoader extends DRACOLoader {
    decodeGeometry(buffer, taskConfig) {
        const startTime = window.performance.now()
        const geometryPromise = super.decodeGeometry(buffer, taskConfig)
        return geometryPromise.then((geometry) => {
            const elapsed = window.performance.now() - startTime
            // eslint-disable-next-line no-param-reassign
            geometry.dracoDecompressTime = elapsed
            return geometry
        })
    }
}

export default CustomDRACOLoader